import React from "react";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import { i18_TRANSLATION } from "../../i18nReferences";

/**
 * Renders login failure or success alert
 * @param {boolean} isLoginFailed - Whether login failed
 * @param {boolean} isLoggedIn - Whether user is logged in
 * @param {string} loginFailedText - Text to display on failure
 * @param {string} successText - Text to display on success
 * @returns {JSX.Element|null} Alert component or null
 */
export const renderLoginAlert = (isLoginFailed, isLoggedIn, loginFailedText, successText) => {
    if (!isLoginFailed && !isLoggedIn) {
        return null;
    }
    if (isLoginFailed) {
        return (
            <React.Fragment>
                <Alert severity="warning">{loginFailedText}</Alert>
            </React.Fragment>
        );
    }
    return (
        <React.Fragment>
            <Alert severity="success">{successText}</Alert>
        </React.Fragment>
    );
};

/**
 * Renders login reset result alert
 * @param {boolean} loginResetResult - Whether reset was initiated
 * @param {string} loginResetError - Error message if reset failed
 * @param {function} t - Translation function
 * @param {string} successKey - Translation key for success message
 * @param {string} [successDefault] - Text used while the key is missing in the translations
 * @returns {JSX.Element|null} Alert component or null
 */
export const renderLoginResetAlert = (loginResetResult, loginResetError, t, successKey, successDefault) => {
    if (!loginResetResult) {
        return null;
    }
    return (
        <Grid>
            <Alert severity={loginResetError ? "error" : "success"}>
                {loginResetError
                    ? t("AUTH.RESET_LOGIN_FAILURE_INFO", {
                          ns: i18_TRANSLATION,
                          error: loginResetError,
                      })
                    : t(successKey, { ns: i18_TRANSLATION, defaultValue: successDefault })}
            </Alert>
        </Grid>
    );
};

